document.documentElement.className = document.documentElement.className.replace(
  "no-js",
  "js",
);
if (Shopify.designMode) {
  document.documentElement.classList.add("shopify-design-mode");
}
function mobileMenu() {
  const header = document.querySelector(".site-header");
  if (header) {
    const mobileMenuToggle = header.querySelector(".mobile-toggle");
    mobileMenuToggle.addEventListener("click", (å) => {
      if (!header.classList.contains("is-level-1-show")) {
        header.classList.add("is-level-1-show");
        let level2Items = document.querySelectorAll("[data-children]");
        if (level2Items) {
          level2Items.forEach((level2Item) => {
            level2Item.classList.remove("flex");
          });
        }
      } else {
        header.classList.remove("is-level-1-show");
        header.classList.remove("is-level-2-show");
        const level2Items = document.querySelectorAll("[data-children]");
        if (level2Items) {
          level2Items.forEach((level2Item) => {
            level2Item.classList.remove("flex");
          });
        }
      }
    });
    const level1Items = document.querySelectorAll("[data-menu]");
    if (level1Items) {
      level1Items.forEach((level1Item) => {
        level1Item.addEventListener("click", (e2) => {
          header.classList.add("is-level-2-show");
          let level2Items = document.querySelectorAll("[data-children]");
          if (level2Items) {
            level2Items.forEach((level2Item) => {
              if (
                level2Item.dataset.children == e2.currentTarget.dataset.menu
              ) {
                level2Item.classList.remove("hidden");
                level2Item.classList.add("flex");
              }
            });
          }
        });
      });
      const backButtons = document.querySelectorAll("[data-menu-back]");
      if (backButtons) {
        backButtons.forEach((backButton) => {
          backButton.addEventListener("click", (e2) => {
            const level2Items = document.querySelectorAll("[data-children]");
            if (level2Items) {
              level2Items.forEach((level2Item) => {
                header.classList.remove("is-level-2-show");
                level2Item.classList.add("hidden");
                level2Item.classList.remove("flex");
              });
            }
          });
        });
      }
    }
    const headerSpace = header.querySelectorAll(".header-space");
    const headerMobile = header.querySelector(".header-mobile");
    if (headerSpace && headerMobile) {
      headerSpace.forEach((headerSpaceItem) => {
        headerSpaceItem.style.paddingTop = headerMobile.clientHeight + "px";
        window.addEventListener("resize", () => {
          headerSpaceItem.style.paddingTop = headerMobile.clientHeight + "px";
        });
      });
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth > 1024) {
        header.classList.remove("is-level-1-show");
        header.classList.remove("is-level-2-show");
      }
    });
  }
}
function footerMenu() {
  const footerMenu2 = document.querySelectorAll(".footer-menu");
  if (footerMenu2) {
    footerMenu2.forEach((footerMenuItem) => {
      const footerMenuToggle = footerMenuItem.querySelector("h3");
      if (footerMenuToggle) {
        footerMenuToggle.addEventListener("click", (e2) => {
          if (
            !e2.currentTarget.parentElement.classList.contains("is-menu-show")
          ) {
            e2.currentTarget.parentElement.classList.add("is-menu-show");
          } else {
            e2.currentTarget.parentElement.classList.remove("is-menu-show");
          }
        });
        window.addEventListener("resize", () => {
          if (window.innerWidth > 640) {
            footerMenuItem.classList.remove("is-menu-show");
          }
        });
      }
    });
  }
}
function pagination() {
  const pagination2 = document.querySelector(".pagination");
  if (!pagination2 || !pagination2.querySelector(".pagination-link")) {
    return;
  }
  if (typeof InfiniteScroll === "undefined") {
    pagination2.classList.add("disabled");
    return;
  } else {
    pagination2.classList.remove("disables");
  }
  window.infScroll = new InfiniteScroll(".pagination-archive", {
    // options
    path: ".pagination-link",
    append: ".pagination-item",
    history: false,
    checkLastPage: false,
    //debug: true,
    scrollThreshold: false,
    button: ".pagination-link",
  });
  infScroll.on("request", function (path, fetchPromise) {
    pagination2.classList.add("is-loading");
  });
  infScroll.on("load", function (body, path, response) {
    pagination2.classList.remove("is-loading");
  });
  infScroll.on("append", function (body, path, items, response) {
    const paginationCount = document.querySelector(".pagination-count");
    if (paginationCount) {
      paginationCount.innerHTML = infScroll.pageIndex;
    }
    items.forEach((item) => {
      var imgs = item.querySelectorAll("img[srcset]");
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        img.outerHTML = img.outerHTML;
      }
    });

    if (typeof updatePriceSubscriptionTime === "function") {
      updatePriceSubscriptionTime();
    }
    if (typeof initSwatches === "function") {
      initSwatches();
    }
  });
  infScroll.on("last", function (body, path) {
    pagination2.classList.remove("is-loading");
    pagination2.classList.add("is-last");
  });
  infScroll.on("error", function (error, path) {
    // console.log("error", error, path);
  });

  const paginationButton = document.querySelector(".pagination-link");
  paginationButton.addEventListener("click", () => {
    //console.log("Button clicked");
  });
  const onIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        paginationButton.click();
      }
    });
  };

  const options = {
    threshold: 1.0, // Set the threshold to 1.0 for the button to be fully visible
  };

  const observer = new IntersectionObserver(onIntersection, options);
  observer.observe(paginationButton);
}
function productGallery() {
  gallery = document.querySelector(".product-gallery");
  if (!gallery) {
    return;
  }
  var pagination2 = new Swiper(".product-gallery-thumbs", {
    slidesPerView: 4,
    spaceBetween: 8,
    watchSlidesProgress: true,
    centerSlides: true,
    breakpoints: {
      400: {
        slidesPerView: 4,
      },
      640: {
        slidesPerView: 6,
      },
      768: {
        slidesPerView: 8,
      },
      1024: {
        slidesPerView: 6,
      },
      1280: {
        slidesPerView: 8,
      },
      1464: {
        slidesPerView: 10,
      },
    },
  });
  const productSlider = new Swiper(gallery, {
    spaceBetween: 0,
    slidesPerView: "auto",
    thumbs: {
      swiper: pagination2,
    },
  });
  return productSlider;
}
function productForm() {
  const productForm2 = document.querySelector(".product-form");
  if (!productForm2) {
    return;
  }

  const optionValues = [...document.querySelectorAll(".option-value")];

  // Initialize all variant options on page load
  initializeVariantOptions();

  // Function to initialize all variant options
  function initializeVariantOptions() {
    if (typeof productVariants === 'undefined' || !productVariants || productVariants.length === 0) return;

    // Map all available variants with their availability status
    const variantAvailabilityMap = {};

    productVariants.forEach((variant) => {
      const key = `${variant.option1}|${variant.option2}|${variant.option3}`;
      variantAvailabilityMap[key] = variant.available;
    });

    // Get all options grouped by option index
    const optionsByIndex = {
      option1: new Set(),
      option2: new Set(),
      option3: new Set(),
    };

    // Collect all option values
    productVariants.forEach((variant) => {
      if (variant.option1) optionsByIndex.option1.add(variant.option1);
      if (variant.option2) optionsByIndex.option2.add(variant.option2);
      if (variant.option3) optionsByIndex.option3.add(variant.option3);
    });

    // Update all option values with their initial availability state
    updateAllOptionAvailability(optionsByIndex, variantAvailabilityMap);
  }

  // Function to update availability for all option values
  function updateAllOptionAvailability(optionsByIndex, variantAvailabilityMap) {
    const fieldsets = document.querySelectorAll(".option");

    fieldsets.forEach((fieldset, fieldsetIndex) => {
      const optionIndex = fieldsetIndex + 1;
      const optionValues = fieldset.querySelectorAll(".option-value");

      optionValues.forEach((optionValue) => {
        // Reset state
        optionValue.classList.remove("disabled", "conditional", "outofstock");
        optionValue.removeAttribute("disabled");

        // Check if this option value is available in any combination
        let isAvailableInSomeVariant = false;
        let isAvailableWithCurrentSelection = false;

        // Get current selections for other options
        const currentSelections = {};
        fieldsets.forEach((fs, idx) => {
          if (idx !== fieldsetIndex) {
            const selectedOption = fs.querySelector(".option-value:checked");
            if (selectedOption) {
              currentSelections[`option${idx + 1}`] = selectedOption.value;
            }
          }
        });

        // Check if this option is available with current selections
        productVariants.forEach((variant) => {
          // Check if this variant matches the current option value
          if (variant[`option${optionIndex}`] === optionValue.value) {
            isAvailableInSomeVariant =
              isAvailableInSomeVariant || variant.available;

            // Check if this variant also matches all other selected options
            let matchesAllSelections = true;
            Object.entries(currentSelections).forEach(([key, value]) => {
              if (variant[key] !== value) {
                matchesAllSelections = false;
              }
            });

            if (matchesAllSelections && variant.available) {
              isAvailableWithCurrentSelection = true;
            }
          }
        });

        // Update styling based on availability
        if (!isAvailableInSomeVariant) {
          // Option is not available in any variant
          optionValue.classList.add("disabled", "outofstock");
          optionValue.setAttribute("disabled", "");
        } else if (
          !isAvailableWithCurrentSelection &&
          Object.keys(currentSelections).length > 0
        ) {
          // Option is available in some variants but not with the current selection
          if (optionValue.hasAttribute("data-multiple-item")) {
            optionValue.classList.remove("conditional");
            optionValue.classList.add("disabled", "outofstock");
            optionValue.setAttribute("disabled", "true");
          } else {
            optionValue.classList.add("conditional");
          }
        }
      });
    });
  }

  // Function to clear incompatible selections when clicking on a conditional option
  function clearIncompatibleSelections(clickedOption) {
    const fieldsets = document.querySelectorAll(".option");
    const clickedOptionIndex = parseInt(
      clickedOption.parentElement.parentElement.parentElement.dataset.index,
    );
    const clickedOptionValue = clickedOption.value;

    // Find compatible variants for the clicked option
    let compatibleVariants = productVariants.filter((variant) => {
      return (
        variant[`option${clickedOptionIndex}`] === clickedOptionValue &&
        variant.available
      );
    });

    // For each fieldset that isn't the clicked one, clear all selections and set a compatible one
    fieldsets.forEach((fieldset, index) => {
      const fieldsetIndex = index + 1;
      if (fieldsetIndex !== clickedOptionIndex) {
        const allOptions = fieldset.querySelectorAll(".option-value");
        const selectedOption = fieldset.querySelector(".option-value:checked");

        // First uncheck all options in this fieldset
        allOptions.forEach((option) => {
          option.checked = false;
          // Remove any previously applied outofstock or conditional classes when resetting
          option.classList.remove("outofstock", "conditional");
        });

        // If we have compatible variants, select the first compatible option
        if (compatibleVariants.length > 0) {
          const firstCompatibleValue =
            compatibleVariants[0][`option${fieldsetIndex}`];
          const compatibleOption = [
            ...fieldset.querySelectorAll(".option-value"),
          ].find((opt) => opt.value === firstCompatibleValue);

          if (compatibleOption) {
            compatibleOption.checked = true;
          }
        }
      }
    });

    // Now select the clicked option (which might have been unchecked during the process)
    clickedOption.checked = true;
    // Remove outofstock class from the clicked option since it's now selected and viable
    clickedOption.classList.remove("outofstock");

    // Trigger a change event to update UI
    const changeEvent = new Event("change", { bubbles: true });
    clickedOption.dispatchEvent(changeEvent);
  }

  if (optionValues) {
    optionValues.forEach((optionValue) => {
      optionValue.addEventListener("click", (e2) => {
        // If clicking on a conditional option, clear incompatible selections
        if (e2.currentTarget.classList.contains("conditional")) {
          if (e2.currentTarget.hasAttribute("data-multiple-item")) {
            // Handle logic for data-multiple-item attribute
            e2.currentTarget.checked = false;
            e2.currentTarget.setAttribute("disabled", "true");
            e2.currentTarget.classList.remove("conditional");
            e2.currentTarget.classList.add("outofstock");
            e2.currentTarget.classList.add("disabled");
            return;
          }
          clearIncompatibleSelections(e2.currentTarget);

          // Manually trigger re-evaluation of variant options after clearing incompatible selections
          setTimeout(() => {
            // Re-evaluate all options after selection change
            const optionsByIndex = {
              option1: new Set(),
              option2: new Set(),
              option3: new Set(),
            };

            // Collect all option values
            productVariants.forEach((variant) => {
              if (variant.option1) optionsByIndex.option1.add(variant.option1);
              if (variant.option2) optionsByIndex.option2.add(variant.option2);
              if (variant.option3) optionsByIndex.option3.add(variant.option3);
            });

            // Create variant availability map
            const variantAvailabilityMap = {};
            productVariants.forEach((variant) => {
              const key = `${variant.option1}|${variant.option2}|${variant.option3}`;
              variantAvailabilityMap[key] = variant.available;
            });

            updateAllOptionAvailability(optionsByIndex, variantAvailabilityMap);
          }, 10);
        }

        const currentFildsetIndex =
          e2.currentTarget.parentElement.parentElement.parentElement.dataset
            .index;

        let selectedOptionOneVariants = productVariants.filter(
          (variant) => e2.currentTarget.value === variant.option1,
        );

        if (currentFildsetIndex == 2) {
          selectedOptionOneVariants = productVariants.filter(
            (variant) => e2.currentTarget.value === variant.option2,
          );
        } else if (currentFildsetIndex == 3) {
          selectedOptionOneVariants = productVariants.filter(
            (variant) => e2.currentTarget.value === variant.option3,
          );
        }

        const inputWrappers = [...document.querySelectorAll(".option")];
        inputWrappers.forEach((option, index) => {
          if (index + 1 != currentFildsetIndex) {
            const optionValues2 = option.querySelectorAll(
              'input[type="radio"]',
            );
            let inputChecked = true;
            optionValues2.forEach((optionValue2) => {
              // Check if there is at least one available variant for this option value
              let hasAvailableVariant = false;
              for (
                let indexNumber = 0;
                indexNumber < inputWrappers.length;
                indexNumber++
              ) {
                if (
                  (inputWrappers.length == 3 &&
                    indexNumber + 1 != currentFildsetIndex &&
                    indexNumber + 1 != index + 1) ||
                  (inputWrappers.length == 2 &&
                    indexNumber != currentFildsetIndex)
                ) {
                  let previousOptionSelected =
                    inputWrappers[indexNumber].querySelector(":checked");

                  if (!previousOptionSelected) {
                    continue;
                  }

                  previousOptionSelected = previousOptionSelected.value;
                  selectedOptionOneVariants.forEach((variant) => {
                    if (
                      variant[`option${index + 1}`] === optionValue2.value &&
                      variant[`option${indexNumber + 1}`] ===
                        previousOptionSelected &&
                      variant.available
                    ) {
                      hasAvailableVariant = true;
                    }
                  });
                }
              }

              if (!optionValue2.checked) {
                if (!hasAvailableVariant) {
                  optionValue2.setAttribute("disabled", "");
                  optionValue2.classList.add("disabled");
                  optionValue2.removeAttribute("checked");
                } else {
                  optionValue2.removeAttribute("disabled");
                  optionValue2.classList.remove("disabled");
                }
              }
            });

            const multipleOptions = option.querySelectorAll(
              'input[type="checkbox"]',
            );
            if (multipleOptions) {
              multipleOptions.forEach((multipleOption) => {
                let hasAvailableVariant = false;
                selectedOptionOneVariants.forEach((variant) => {
                  if (
                    variant[`option${index + 1}`] === multipleOption.value &&
                    variant.available
                  ) {
                    hasAvailableVariant = true;
                  }
                });
                if (!multipleOption.checked) {
                  if (!hasAvailableVariant) {
                    multipleOption.setAttribute("disabled", "");
                    multipleOption.classList.add("disabled");
                    multipleOption.removeAttribute("checked");
                  } else {
                    multipleOption.removeAttribute("disabled");
                    multipleOption.classList.remove("disabled");
                  }
                }
              });
            }
          }
        });

        // Re-evaluate all options after selection change
        const optionsByIndex = {
          option1: new Set(),
          option2: new Set(),
          option3: new Set(),
        };

        // Collect all option values
        productVariants.forEach((variant) => {
          if (variant.option1) optionsByIndex.option1.add(variant.option1);
          if (variant.option2) optionsByIndex.option2.add(variant.option2);
          if (variant.option3) optionsByIndex.option3.add(variant.option3);
        });

        // Create variant availability map
        const variantAvailabilityMap = {};
        productVariants.forEach((variant) => {
          const key = `${variant.option1}|${variant.option2}|${variant.option3}`;
          variantAvailabilityMap[key] = variant.available;
        });

        updateAllOptionAvailability(optionsByIndex, variantAvailabilityMap);

        const selectedVariant = getSelectedVariant();
        if (selectedVariant) {
          updatePrice(selectedVariant);
          const addToCartButton = document.querySelector(".add-to-cart-button");
          if (selectedVariant.available) {
            if (addToCartButton.classList.contains("has-out-of-stock")) {
              addToCartButton.classList.remove("has-out-of-stock");
            }
          } else {
            if (!addToCartButton.classList.contains("has-out-of-stock")) {
              addToCartButton.classList.add("has-out-of-stock");
            }
          }
          const variantId = document.querySelector(".product-variant-id");
          if (variantId) {
            variantId.value = selectedVariant.id;
          }
          const productSlider = productGallery();
          if (productSlider) {
            productSlider.slides.forEach((slide, index) => {
              if (selectedVariant.featured_image != null) {
                if (selectedVariant.featured_media.id == slide.dataset.id) {
                  productSlider.slideTo(index);
                }
              }
            });
          }
        }
      });
    });
  }
  const quantityWrapper = document.querySelector(".quantity");
  if (quantityWrapper) {
    const plus = quantityWrapper.querySelector(".quantity-plus");
    const minus = quantityWrapper.querySelector(".quantity-minus");
    const input = quantityWrapper.querySelector("input");
    plus.addEventListener("click", () => {
      input.value++;
    });
    minus.addEventListener("click", () => {
      if (input.value > 1) input.value--;
    });
  }
  let isAddingToCart = false;
  if ("liquidAjaxCart" in window) {
    liquidAjaxCart.subscribeToCartStateUpdate((state, isCartUpdated) => {
      // console.log("State is updated: ", state);
      // console.log("Cart state is updated: ", isCartUpdated);
      updatePriceSubscriptionTime();
    });
    liquidAjaxCart.subscribeToCartAjaxRequests(
      (requestState, subscribeToResult) => {
        updatePriceSubscriptionTime();
        // console.log("state", requestState);
        if (requestState.requestType === "add" && !isAddingToCart) {
          subscribeToResult((requestState2) => {
            //console.log(requestState2);
            isAddingToCart = true;
            const multipleItems = getMultipleVariant();
            const selectedVariant = getSelectedVariant();
            //console.log(getMultipleVariant());
            const items = [];
            if (multipleItems) {
              multipleItems.forEach((multipleItem) => {
                if (multipleItem != selectedVariant.id) {
                  items.push({ id: multipleItem, quantity: 1 });
                }
              });

              liquidAjaxCart.cartRequestAdd(
                {
                  items,
                },
                {
                  lastComplete: (requestState) => {
                    //console.log("Last request complete:", requestState);
                    isAddingToCart = false; // Reset the flag after completion
                    if (requestState2.responseData?.ok) {
                      document.body.classList.add("js-side-cart-open");
                      setTimeout(() => {
                        document.body.classList.remove("js-side-cart-open");
                      }, 5000);
                    }
                  },
                },
              );
            } else {
              // Single variant product - open side cart and reset flag
              isAddingToCart = false;
              if (requestState2.responseData?.ok) {
                document.body.classList.add("js-side-cart-open");
                setTimeout(() => {
                  document.body.classList.remove("js-side-cart-open");
                }, 5000);
              }
            }
          });
        }
      },
    );
  }

  document.addEventListener("liquid-ajax-cart:request-end", function (event) {
    const { requestState, cart, previousCart, sections } = event.detail;

    // Check if this was a /cart/change.js request (adjust 'change' to 'update' or others if needed)
    if (requestState.requestBody?.url?.includes("/cart/change.js")) {
      // console.log(
      //   "Cart change complete — caches cleared (Clear-Site-Data processed). Running your script!"
      // );

      // YOUR CUSTOM SCRIPT HERE
      updatePriceSubscriptionTime();
    }
  });
}
function updatePrice(selectedVariant) {
  if (!selectedVariant) {
    return;
  }
  const priceWrapper = document.querySelector(".price");
  if (priceWrapper) {
    let comparePrice = "";
    let mainPrice = "";
    if (
      selectedVariant.compare_at_price != null &&
      selectedVariant.compare_at_price > selectedVariant.price
    ) {
      comparePrice = document.createElement("del");
      comparePrice.setAttribute(
        "class",
        "compare-at-price leading-none text-text-gray text-2xl font-light decoration-red-500/80 tracking-tighter mr-1",
      );
      comparePrice.innerHTML = (
        selectedVariant.compare_at_price / 100
      ).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      mainPrice = document.createElement("span");
      mainPrice.setAttribute(
        "class",
        "price-main leading-none text-dark-blue font-bold text-2xl",
      );
      mainPrice.innerHTML = (selectedVariant.price / 100).toLocaleString(
        "en-US",
        {
          style: "currency",
          currency: "USD",
        },
      );
    } else {
      mainPrice = document.createElement("span");
      mainPrice.setAttribute(
        "class",
        "price-main leading-none text-dark-blue font-bold text-4xl",
      );
      mainPrice.innerHTML = (selectedVariant.price / 100).toLocaleString(
        "en-US",
        {
          style: "currency",
          currency: "USD",
        },
      );
    }
    const layBuy = document.querySelector("[data-laybuy-price]");
    if (layBuy) {
      layBuy.innerHTML = (selectedVariant.price / 600).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    }
    const afterPay = document.querySelector("[data-afterpay-price]");
    if (afterPay) {
      afterPay.innerHTML = (selectedVariant.price / 400).toLocaleString(
        "en-US",
        {
          style: "currency",
          currency: "USD",
        },
      );
    }
    if (mainPrice || comparePrice) {
      priceWrapper.innerHTML = "";
      priceWrapper.append(comparePrice);
      priceWrapper.append(mainPrice);
    }
  }
}
function getSelectedVariant() {
  const options = document.querySelector(".options");
  if (!options) return null;
  const fieldsets = document.querySelectorAll(".option");
  const selectedOptionValues = [...options.querySelectorAll(":checked")];
  const option1 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option1",
  );
  const option2 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option2",
  );
  const option3 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option3",
  );
  switch (fieldsets.length) {
    case 1:
      return (
        productVariants.filter(
          (variant) => option1[0]?.value === variant.option1,
        )[0] || null
      );
    case 2:
      return (
        productVariants.filter(
          (variant) =>
            option1[0]?.value === variant.option1 &&
            option2[0]?.value === variant.option2,
        )[0] || null
      );
    case 3:
      return (
        productVariants.filter(
          (variant) =>
            option1[0]?.value === variant.option1 &&
            option2[0]?.value === variant.option2 &&
            option3[0]?.value === variant.option3,
        )[0] || null
      );
  }
}

function getMultipleVariant() {
  const options = document.querySelector(".options");
  if (!options) return null;
  const fieldsets = document.querySelectorAll(".option");
  const selectedOptionValues = [...options.querySelectorAll(":checked")];
  let multipleFieldset = "1";
  const selectedVariants = [];
  const option1 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option1",
  );

  const option2 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option2",
  );

  const option3 = selectedOptionValues.filter(
    (optionValue) => optionValue.dataset.optionIndex == "option3",
  );

  if (fieldsets) {
    fieldsets.forEach((fieldset) => {
      if (fieldset.hasAttribute("data-multiple-option")) {
        multipleFieldset = parseInt(fieldset.dataset.index);
      }
    });
  }

  // Helper function to check and disable out-of-stock options
  function checkAndDisableOutOfStock() {
    fieldsets.forEach((fieldset, fieldsetIndex) => {
      if (fieldset.hasAttribute("data-multiple-option")) {
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        radios.forEach((radio) => {
          // Check if this option value has any available variants
          let hasAvailableVariant = false;

          switch (fieldsets.length) {
            case 1:
              hasAvailableVariant = productVariants.some(
                (variant) =>
                  variant.option1 === radio.value && variant.available,
              );
              break;
            case 2:
              if (fieldsetIndex === 0) {
                // option1
                hasAvailableVariant = productVariants.some(
                  (variant) =>
                    variant.option1 === radio.value &&
                    variant.option2 === option2[0]?.value &&
                    variant.available,
                );
              } else {
                // option2
                hasAvailableVariant = productVariants.some(
                  (variant) =>
                    variant.option1 === option1[0]?.value &&
                    variant.option2 === radio.value &&
                    variant.available,
                );
              }
              break;
            case 3:
              if (fieldsetIndex === 0) {
                // option1
                hasAvailableVariant = productVariants.some(
                  (variant) =>
                    variant.option1 === radio.value &&
                    variant.option2 === option2[0]?.value &&
                    variant.option3 === option3[0]?.value &&
                    variant.available,
                );
              } else if (fieldsetIndex === 1) {
                // option2
                hasAvailableVariant = productVariants.some(
                  (variant) =>
                    variant.option1 === option1[0]?.value &&
                    variant.option2 === radio.value &&
                    variant.option3 === option3[0]?.value &&
                    variant.available,
                );
              } else {
                // option3
                hasAvailableVariant = productVariants.some(
                  (variant) =>
                    variant.option1 === option1[0]?.value &&
                    variant.option2 === option2[0]?.value &&
                    variant.option3 === radio.value &&
                    variant.available,
                );
              }
              break;
          }

          // Disable if no available variants found
          if (!hasAvailableVariant) {
            radio.setAttribute("disabled", "");
            radio.classList.add("disabled");
            radio.parentElement.classList.add("disabled");
          } else {
            radio.removeAttribute("disabled");
            radio.classList.remove("disabled");
            radio.parentElement.classList.remove("disabled");
          }
        });
      }
    });
  }

  switch (fieldsets.length) {
    case 1:
      option1.forEach((option1Item) => {
        const variant = productVariants.filter(
          (variant) => option1Item.value === variant.option1,
        )[0];
        if (variant) selectedVariants.push(variant.id);
      });
      break;
    case 2:
      switch (multipleFieldset) {
        case 1:
          option1.forEach((option1Item) => {
            const variant = productVariants.filter(
              (variant) =>
                option1Item.value === variant.option1 &&
                option2[0].value === variant.option2,
            )[0];
            if (variant) selectedVariants.push(variant.id);
          });
          break;
        case 2:
          option2.forEach((option2Item) => {
            const variant = productVariants.filter(
              (variant) =>
                option1[0].value === variant.option1 &&
                option2Item.value === variant.option2,
            )[0];
            if (variant) selectedVariants.push(variant.id);
          });
          break;
      }
      break;
    case 3:
      switch (multipleFieldset) {
        case 1:
          option1.forEach((option1Item) => {
            const variant = productVariants.filter(
              (variant) =>
                option1Item.value === variant.option1 &&
                option2[0].value === variant.option2 &&
                option3[0].value === variant.option3,
            )[0];
            if (variant) selectedVariants.push(variant.id);
          });
          break;
        case 2:
          option2.forEach((option2Item) => {
            const variant = productVariants.filter(
              (variant) =>
                option1[0].value === variant.option1 &&
                option2Item.value === variant.option2 &&
                option3[0].value === variant.option3,
            )[0];
            if (variant) selectedVariants.push(variant.id);
          });
          break;
        case 3:
          option3.forEach((option3Item) => {
            const variant = productVariants.filter(
              (variant) =>
                option1[0].value === variant.option1 &&
                option2[0].value === variant.option2 &&
                option3Item.value === variant.option3,
            )[0];
            if (variant) selectedVariants.push(variant.id);
          });
          break;
      }
      break;
  }

  // Check and disable out-of-stock options
  checkAndDisableOutOfStock();

  return selectedVariants;
}

/**
 * Function will work when has multiple variant items.
 */
function multipleVariantItems() {
  const multipleVariantField = document.querySelector("[data-multiple-option]");
  if (multipleVariantField) {
    // Listen for the "liquid-ajax-cart:request-end" event which is fired
    // after a Shopify Cart API Ajax request is performed
    // document.addEventListener('liquid-ajax-cart:request-end', event => {
    //   const {requestState} = event.detail;
    //   // If the "add to cart" request is successful
    //   if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    //     // Add the CSS class to the "body" tag
    //     //document.body.classList.add('js-show-ajax-cart');
    //   }
    // });
  }
}

function heroSlider() {
  const heroSlider2 = document.querySelectorAll(".hero-slider");
  if (heroSlider2) {
    heroSlider2.forEach((slider) => {
      const slides = slider.querySelectorAll(".swiper-slide");
      if (slides && slides.length > 1) {
        var heroSliderObject = new Swiper(slider, {
          slidesPerView: 1,
          spaceBetween: 0,
          setWrapperSize: true,
          loop: true,
          autoplay: {
            delay: 3e3,
          },
          pagination: {
            el: ".swiper-pagination",
            bulletActiveClass: "swiper-pagination-bullet-active bg-white",
            clickable: true,
          },
        });
      }
    });
  }
}
function brandsSlider() {
  const brandsSliderEl = document.querySelectorAll(".brands-slider");
  if (brandsSliderEl) {
    brandsSliderEl.forEach((slider) => {
      const next = slider.parentNode.querySelector(".swiper-button-next");
      const prev = slider.parentNode.querySelector(".swiper-button-prev");
      var brandsSliderObject = new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 16,
        breakpoints: {
          640: {
            slidesPerView: 4,
            spaceBetween: 16,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 7,
            spaceBetween: 16,
          },
          1280: {
            slidesPerView: 10,
            spaceBetween: 16,
          },
          1536: {
            slidesPerView: 10,
            spaceBetween: 24,
          },
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  }
}
function productTabs() {
  const productTabs2 = document.querySelectorAll(".product-tabs");
  {
    if (productTabs2) {
      productTabs2.forEach((productTab) => {
        const tabCarousel = productTab.querySelectorAll(".tab-carousel");
        const tabHeaders = productTab.querySelectorAll(".tab-header-item");
        const tabContents = productTab.querySelectorAll(".tab-content-item");
        if (tabCarousel) {
          tabCarousel.forEach((tabCarouselItem) => {
            const next = tabCarouselItem.parentNode.querySelector(
              ".swiper-button-next",
            );
            const prev = tabCarouselItem.parentNode.querySelector(
              ".swiper-button-prev",
            );
            new Swiper(tabCarouselItem, {
              slidesPerView: "auto",
              navigation: {
                nextEl: next,
                prevEl: prev,
              },
              on: {
                init: function () {
                  if (tabHeaders && tabContents) {
                    tabHeaders[0].classList.add("is-active");
                    tabContents[0].classList.remove("first:block");
                    tabContents[0].classList.remove("hidden");
                    tabContents[0].classList.add("block");
                  }
                },
              },
            });
          });
        }
        if (tabHeaders && tabContents) {
          if (tabHeaders.length == 1) {
            productTabs2.classList.add("is-tab-disabled");
          } else {
            tabHeaders.forEach((tabHeader) => {
              tabHeader.addEventListener("click", (e2) => {
                tabHeaders.forEach((tabHeader2) => {
                  if (e2.currentTarget.dataset.id == tabHeader2.dataset.id) {
                    tabHeader2.classList.add("is-active");
                  } else {
                    tabHeader2.classList.remove("is-active");
                  }
                });
                tabContents.forEach((tabContent) => {
                  if (e2.currentTarget.dataset.id == tabContent.dataset.id) {
                    tabContent.classList.add("block");
                    tabContent.classList.remove("hidden");
                  } else {
                    tabContent.classList.remove("block");
                    tabContent.classList.add("hidden");
                  }
                });
              });
            });
          }
        }
      });
    }
  }
}
function productInfoTabs() {
  const productTabs2 = document.querySelector(".product-info-tabs");
  if (productTabs2) {
    const tabNames = productTabs2.querySelectorAll(".product-tab-name");
    const tabContents = productTabs2.querySelectorAll(".product-tab-content");
    if (tabNames && tabContents) {
      if (!tabNames[0].classList.contains("is-active")) {
        tabNames[0].classList.add("is-active");
        tabContents[0].classList.remove("hidden");
        tabContents[0].classList.add("block");
      }
      tabNames.forEach((tabName) => {
        tabName.addEventListener("click", (e2) => {
          tabNames.forEach((tabNameItem) => {
            if (e2.currentTarget.dataset.tab != tabNameItem.dataset.tab) {
              tabNameItem.classList.remove("is-active");
            } else {
              if (!tabNameItem.classList.contains("is-active")) {
                tabNameItem.classList.add("is-active");
              }
            }
          });
          tabContents.forEach((tabContent) => {
            if (e2.currentTarget.dataset.tab != tabContent.dataset.tab) {
              tabContent.classList.remove("block");
              tabContent.classList.add("hidden");
            } else {
              tabContent.classList.add("block");
              tabContent.classList.remove("hidden");
            }
          });
        });
      });

      const reviewMeta = document.querySelector("[data-review-meta]");
      if (reviewMeta) {
        reviewMeta.addEventListener("click", () => {
          tabNames.forEach((tabNameItem) => {
            if (
              tabNameItem.dataset.tab &&
              !tabNameItem.dataset.tab.includes(
                "judge_me_reviews_review_widget",
              )
            ) {
              tabNameItem.classList.remove("is-active");
            } else {
              if (!tabNameItem.classList.contains("is-active")) {
                tabNameItem.classList.add("is-active");
              }
            }
          });
          tabContents.forEach((tabContent) => {
            if (
              !tabContent.dataset.tab.includes("judge_me_reviews_review_widget")
            ) {
              tabContent.classList.remove("block");
              tabContent.classList.add("hidden");
            } else {
              tabContent.classList.add("block");
              tabContent.classList.remove("hidden");
            }
          });
          productTabs2.scrollIntoView({ behavior: "smooth" });
        });
      }
    }
  }
}
function imageGallery() {
  const imageGallery2 = document.querySelectorAll(".image-gallery");
  if (!imageGallery2) {
    return;
  }
  imageGallery2.forEach((gallery2) => {
    var swiper = new Swiper(gallery2, {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });
}
function relatedProducts() {
  const relatedProducts2 = document.querySelector(".related-products");
  if (!relatedProducts2) {
    return;
  }
  const relatedProductsWrapper = document.querySelector(
    ".product-recommendations",
  );

  if (!relatedProductsWrapper) {
    return;
  }
  const dataUrl = relatedProductsWrapper.dataset.url;
  fetch(dataUrl)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const check = html.querySelector(".swiper");
      if (!check) {
        return;
      }
      relatedProducts2.classList.remove("hidden");
      const recommendations = html.querySelector(".product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        relatedProductsWrapper.innerHTML = recommendations.innerHTML;
        new Swiper(relatedProductsWrapper.querySelector(".swiper"), {
          slidesPerView: "auto",
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            init: function () {},
          },
        });
        if (typeof initSwatches === "function") {
          initSwatches();
        }
      }
    })
    .catch((e2) => {
      console.error(e2);
    });
}
function loginPage() {
  const loginSection = document.querySelector(".login-section");
  if (!loginSection) {
    return;
  }
  const loginGroup = document.querySelector(".login-group");
  //console.log(window.location.hash);
  if (window.location.hash) {
    if (window.location.hash == "#recover") {
      loginGroup.classList.add("is-reset");
    }
  }
  loginSection.classList.add("is-ready");
  const resetLink = document.querySelector(".reset-link");
  if (resetLink) {
    resetLink.addEventListener("click", (e2) => {
      e2.preventDefault();
      loginGroup.classList.add("is-reset");
      if (window.location.hash.substring(1) != "recover") {
        window.location.hash = "recover";
      }
    });
  }
  const cancelLink = document.querySelector(".cancel-link");
  if (cancelLink) {
    cancelLink.addEventListener("click", (e2) => {
      e2.preventDefault();
      loginGroup.classList.remove("is-reset");
      if (window.location.hash.substring(1) == "recover") {
        window.location.hash = "";
      }
    });
  }
}
function accountForm() {
  const addresses = document.querySelectorAll("[data-address]");
  if (addresses) {
    addresses.forEach((address) => {
      const showButton = address.querySelector("[data-address-show]");
      const closeButton = address.querySelector("[data-address-close]");
      const addressDialog = address.querySelector("[data-address-dialog]");
      showButton.addEventListener("click", (e2) => {
        addressDialog.showModal();
      });
      closeButton.addEventListener("click", (e2) => {
        addressDialog.close();
      });
    });
  }
  const countrySelectors = document.querySelectorAll(
    "[data-address-country-select]",
  );
  if (countrySelectors) {
    countrySelectors.forEach((countrySelector) => {
      const options = countrySelector.querySelectorAll("option");
      if (options) {
        options.forEach((option) => {
          if (option.value == countrySelector.dataset.default) {
            option.setAttribute("selected", "selected");
          }
        });
      }
      if (
        JSON.parse(
          countrySelector.options[countrySelector.selectedIndex].dataset
            .provinces,
        ).length > 0
      ) {
        const provinceWrapper =
          countrySelector.parentElement.parentElement.querySelector(
            "[data-address-province]",
          );
        const provinceSelect =
          countrySelector.parentElement.parentElement.querySelector(
            "[data-address-province-input]",
          );
        provinceSelect.innerHTML = "";
        provinceWrapper.classList.remove("hidden");
        provinceWrapper.classList.add("flex");
        JSON.parse(
          countrySelector.options[countrySelector.selectedIndex].dataset
            .provinces,
        ).forEach((province) => {
          const provinceOption = document.createElement("option");
          provinceOption.value = province[0];
          provinceOption.innerHTML = province[1];
          if (provinceOption.value == provinceSelect.dataset.default) {
            provinceOption.setAttribute("selected", "selected");
          }
          provinceSelect.appendChild(provinceOption);
        });
      }
      countrySelector.addEventListener("change", (e2) => {
        const provinceArray = JSON.parse(
          e2.target.options[e2.target.selectedIndex].dataset.provinces,
        );
        const provinceSelector =
          e2.target.parentElement.parentElement.querySelector(
            "[data-address-province]",
          );
        const provinceInput =
          e2.target.parentElement.parentElement.querySelector(
            "[data-address-province-input]",
          );
        if (provinceArray.length > 0) {
          provinceInput.innerHTML = "";
          provinceSelector.classList.remove("hidden");
          provinceSelector.classList.add("flex");
          provinceArray.forEach((province) => {
            const option = document.createElement("option");
            option.value = province[0];
            option.innerHTML = province[1];
            provinceInput.appendChild(option);
          });
        } else {
          provinceSelector.classList.add("hidden");
          provinceSelector.classList.remove("flex");
        }
      });
    });
  }
}
function filters() {
  const filterOpen = document.querySelector("[data-filter-toggle]");
  if (filterOpen) {
    filterOpen.addEventListener("click", (e2) => {
      e2.preventDefault();
      if (!document.body.classList.contains("is-filter-open")) {
        document.body.classList.add("is-filter-open");
      }
    });
  }
  const filterCloseButtons = document.querySelectorAll("[data-filter-close]");
  if (filterCloseButtons) {
    filterCloseButtons.forEach((filterClose) => {
      filterClose.addEventListener("click", (e2) => {
        e2.preventDefault();
        if (document.body.classList.contains("is-filter-open")) {
          document.body.classList.remove("is-filter-open");
        }
      });
    });

    const filterVisible = document.querySelector("[data-filter-visible]");
    if (filterVisible) {
      const checkFilterVisibility = () => {
        if (
          window.innerWidth >= 1024 &&
          document.body.classList.contains("is-filter-open")
        ) {
          document.body.classList.remove("is-filter-open");
        }
      };
      checkFilterVisibility();
      window.addEventListener("resize", checkFilterVisibility);
    }
  }
  const sortForm = document.querySelector("[data-sort-form]");
  if (sortForm) {
    const sortSelect = sortForm.querySelector("[data-sort-select]");
    sortSelect.addEventListener("change", (e2) => {
      const currentValue = sortSelect.value;

      // URL-д ? тэмдэг буюу query parameter байгаа эсэхийг шалгана
      // window.location.search нь ?page=1 гэх мэт хэсгийг буцаадаг. Хоосон бол "" байна.
      const hasParams = window.location.search.length > 0;

      // Хэрэв sort_by аль хэдийн байгаа эсэхийг шалгах бол URLSearchParams ашиглах нь дээр ч,
      // энгийнээр ингэж бичиж болно:

      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has("sort_by")) {
        // Байвал утгыг нь солино
        urlParams.set("sort_by", currentValue);
        window.location.search = urlParams.toString();
      } else {
        // Байхгүй бол нэмнэ.
        // hasParams true бол (өөр filter байгаа) '&' залгана, false бол '?' залгана.
        const separator = hasParams ? "&" : "?";
        window.location.href =
          window.location.href + separator + "sort_by=" + currentValue;
      }
    });
  }
}
function contactPage() {
  const contact = document.querySelector(".contact");
  if (contact) {
    const maps = contact.querySelectorAll("[data-map]");
    const locations = contact.querySelectorAll("[data-location]");
    locations.forEach((location) => {
      location.addEventListener("click", (e2) => {
        locations.forEach((location2) => {
          location2.classList.remove("active");
        });
        e2.currentTarget.classList.add("active");
        maps.forEach((map) => {
          if (map.dataset.map == e.currentTarget.dataset.location) {
            map.classList.remove("hidden");
          } else {
            map.classList.add("hidden");
          }
        });
      });
    });
  }
}
function searchForm() {
  const searchOpen = document.querySelectorAll(".icon-search");
  const searchClose = document.querySelectorAll("[data-search-close]");
  searchOpen.forEach((open) => {
    open.addEventListener("click", () => {
      document.body.classList.add("is-search-open");
    });
  });
  if (searchClose) {
    searchClose.forEach((close) => {
      close.addEventListener("click", () => {
        document.body.classList.remove("is-search-open");
      });
    });
  }
  const form = document.querySelector("[data-search-form]");
  const searchInput = document.querySelector("[data-search-input]");
  if (searchInput) {
    searchInput.addEventListener("keyup", (e2) => {
      const value = e2.target.value;
      if (value.length > 2) {
        fetch("/search/suggest?q=" + value + "&section_id=predictive-search")
          .then((response) => {
            if (!response.ok) {
              var error = new Error(response.status);
              throw error;
            }
            return response.text();
          })
          .then((text) => {
            const resultsMarkup = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector("#shopify-section-predictive-search").innerHTML;
            const wrapper = document.querySelector(
              "#shopify-section-predictive-search",
            );
            if (wrapper) {
              wrapper.innerHTML = resultsMarkup;
              const button = wrapper.querySelector("[data-search-button]");

              button.addEventListener("click", (e3) => {
                e3.preventDefault();
                form.submit();
              });
            }
          })
          .catch((error) => {
            throw error;
          });
      } else {
      }
    });
  }
}

function mobilePredictiveSearch() {
  const mobileInput = document.querySelector("[data-mobile-search-input]");
  const mobileForm = document.getElementById("mobile-search-form");
  const mobileResults = document.getElementById("mobile-search-results");
  if (!mobileInput || !mobileResults) return;

  mobileInput.addEventListener("keyup", (e) => {
    const value = e.target.value;
    if (value.length > 2) {
      fetch("/search/suggest?q=" + encodeURIComponent(value) + "&section_id=predictive-search&resources[type]=product&resources[limit]=10")
        .then((res) => { if (!res.ok) throw new Error(res.status); return res.text(); })
        .then((text) => {
          const markup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-predictive-search").innerHTML;
          mobileResults.innerHTML = markup;
          mobileResults.classList.remove("hidden");
          const btn = mobileResults.querySelector("[data-search-button]");
          if (btn) {
            btn.addEventListener("click", (e2) => {
              e2.preventDefault();
              mobileForm.submit();
            });
          }
        })
        .catch(() => {});
    } else {
      mobileResults.classList.add("hidden");
      mobileResults.innerHTML = "";
    }
  });

  mobileInput.addEventListener("input", () => {
    if (mobileInput.value.length === 0) {
      mobileResults.classList.add("hidden");
      mobileResults.innerHTML = "";
    }
  });

  document.addEventListener("click", (e) => {
    if (!mobileInput.contains(e.target) && !mobileResults.contains(e.target)) {
      mobileResults.classList.add("hidden");
    }
  });
}

function childrenCollections() {
  const childrenCollection = document.querySelectorAll(
    "[data-children-collections]",
  );
  if (childrenCollection) {
    childrenCollection.forEach((collection) => {
      const nextBtn = collection.querySelector(".swiper-button-next");
      const prevBtn = collection.querySelector(".swiper-button-prev");
      new Swiper(collection, {
        slidesPerView: "auto",
        spaceBetween: 0,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }
}

function headerCollectionMenu() {
  const parentCollections = document.querySelectorAll(
    "[data-parent-collection]",
  );
  if (parentCollections) {
    parentCollections.forEach((parentCollection) => {
      parentCollection.addEventListener("click", (e) => {
        e.preventDefault();
        let wrapperNode = e.currentTarget.parentNode.parentNode.parentNode;
        let minHeight = e.currentTarget.parentNode.parentNode.offsetHeight;
        if (e.currentTarget.classList.contains("mobile-collection")) {
          wrapperNode =
            e.currentTarget.parentNode.parentNode.parentNode.parentNode;
        }
        //console.log(e.currentTarget.classList);
        if (wrapperNode.classList.contains("mega-menu-collection-wrapper")) {
          const childrenCollection = wrapperNode.querySelector(
            "[data-children-collection]",
          );
          const backParent = wrapperNode.querySelector("[data-parent-back]");
          const childrenContent = e.currentTarget.nextElementSibling;
          const parentLabel = wrapperNode.querySelector("[data-parent-label]");
          childrenCollection.innerHTML = "";
          parentLabel.innerText = e.currentTarget.dataset.parentLabelValue;
          wrapperNode.classList.add("show-children");
          childrenCollection.style.setProperty(
            "--min-height",
            minHeight + "px",
          );
          childrenCollection.innerHTML = childrenContent.innerHTML;

          backParent.addEventListener("click", () => {
            wrapperNode.classList.remove("show-children");
          });
        }
      });
    });
  }
}

function fittingSlider() {
  const el = document.querySelectorAll("[data-fitting-slider]");
  if (el) {
    el.forEach((element) => {
      new Swiper(element, {
        slidesPerView: 1,
        spaceBetween: 8,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 3,
          },
        },
        navigation: {
          nextEl: ".fitting-button-next",
          prevEl: ".fitting-button-prev",
        },
      });
    });
  }
}

window.updatePriceSubscriptionTime = updatePriceSubscriptionTime;
function updatePriceSubscriptionTime() {
  const storedPriceData = localStorage.getItem("priceSubscription");
  const storedCustomData = localStorage.getItem("customBallsSubscription");
  const SUBSCRIPTION_DURATION = 2 * 60 * 60 * 1000; // 2 hours
  const currentTime = Date.now();

  let data = storedPriceData ? JSON.parse(storedPriceData) : null;
  let customData = storedCustomData ? JSON.parse(storedCustomData) : null;

  // Check if either subscription exists and is still valid
  const isGenericValid = data && (currentTime - data.subscribedAt < SUBSCRIPTION_DURATION);
  const isCustomValid = customData && (currentTime - customData.subscribedAt < SUBSCRIPTION_DURATION);

  // Synchronize: If one is valid and has showPrice: true, the other should too
  let shouldShowPrice = false;
  
  if (isGenericValid && data.showPrice) {
    shouldShowPrice = true;
    // Sync priceSub to customData
    if (customData) {
      customData.showPrice = true;
      customData.subscribedAt = currentTime;
    } else {
      // Create stub
      customData = { 
        firstName: data.firstName || 'Subscriber', 
        email: data.email || '', 
        subscribedAt: currentTime, 
        showPrice: true 
      };
    }
    localStorage.setItem("customBallsSubscription", JSON.stringify(customData));
  }

  if (isCustomValid && customData.showPrice) {
    shouldShowPrice = true;
    // Sync customData to generic data
    if (data) {
      data.showPrice = true;
      data.subscribedAt = currentTime;
    } else {
      // Create stub
      data = { 
        firstName: customData.firstName || 'Subscriber', 
        email: customData.email || '', 
        subscribedAt: currentTime, 
        showPrice: true 
      };
    }
    localStorage.setItem("priceSubscription", JSON.stringify(data));
  }

  const pdpPriceWrappers = document.querySelectorAll("[data-price-wrapper]");
  const pdpPriceRevealers = document.querySelectorAll(".price-revealer");

  if (shouldShowPrice) {
    // Reveal prices only in cart contexts (side cart + cart page)
    document.querySelectorAll(
      ".c-side-cart [data-hidden-price], .main-cart [data-hidden-price]"
    ).forEach((el) => {
      el.dataset.hiddenPrice = "false";
    });

    // Set global body status
    document.body.dataset.priceStatus = "visible";

    // Reveal PDP prices
    if (pdpPriceWrappers.length > 0) {
      pdpPriceWrappers.forEach((pdpPriceWrapper) => {
        pdpPriceWrapper.classList.remove("hidden");
        pdpPriceWrapper.classList.add("block");
      });
    }

    // Hide reveal buttons on PDP
    if (pdpPriceRevealers.length > 0) {
      pdpPriceRevealers.forEach((pdpPriceRevealer) => {
        pdpPriceRevealer.classList.add("hidden");
      });
    }

    // Prolong generic subscription if valid
    if (isGenericValid && data) {
      data.subscribedAt = currentTime;
      localStorage.setItem("priceSubscription", JSON.stringify(data));
    }
    // Prolong custom subscription if valid
    if (isCustomValid && customData) {
      customData.subscribedAt = currentTime;
      localStorage.setItem("customBallsSubscription", JSON.stringify(customData));
    }
  } else {
    document.body.dataset.priceStatus = "hidden";
    // Clean up expired ones
    if (data && !isGenericValid) localStorage.removeItem("priceSubscription");
    if (customData && !isCustomValid) localStorage.removeItem("customBallsSubscription");
  }
}

function sideCartScrollLock() {
  let scrollY = 0;
  let wasOpen = document.body.classList.contains('js-side-cart-open');

  new MutationObserver(() => {
    const isOpen = document.body.classList.contains('js-side-cart-open');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    if (isOpen) {
      scrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = '';
      window.scrollTo(0, scrollY);
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
}

function stickyATC() {
  const bar = document.querySelector('.sticky-atc-bar');
  if (!bar) return;

  const mainAtcBtn = document.querySelector('.add-to-cart-button');
  const drawer = document.querySelector('.sticky-atc-drawer');
  if (!mainAtcBtn || !drawer) return;

  // Move bar and drawer to <body> so they're in the root stacking context,
  // above any section that creates a stacking context (Swiper transforms, etc.)
  document.body.appendChild(bar);
  document.body.appendChild(drawer);

  const sheet = drawer.querySelector('.sticky-atc-sheet');
  const backdrop = drawer.querySelector('.sticky-atc-backdrop');
  const trigger = bar.querySelector('.sticky-atc-trigger');
  const stickyPriceEl = bar.querySelector('.sticky-atc-price');
  const drawerPriceEl = drawer.querySelector('.sticky-atc-drawer-price');
  const optionsContainer = drawer.querySelector('.sticky-atc-options-container');
  const qtyMinus = drawer.querySelector('.sticky-atc-qty-minus');
  const qtyPlus = drawer.querySelector('.sticky-atc-qty-plus');
  const qtyDisplay = drawer.querySelector('.sticky-atc-qty-display');
  const drawerSubmit = drawer.querySelector('.sticky-atc-drawer-submit');
  const mainOptionsEl = document.querySelector('.options');
  const mainQtyInput = document.querySelector('.quantity-input');

  let stickyQty = 1;
  let menuOpen = false;

  // Hide bar when mobile menu is open
  const siteHeader = document.querySelector('.site-header');
  if (siteHeader) {
    new MutationObserver(() => {
      menuOpen = siteHeader.classList.contains('is-level-1-show');
      bar.style.transform = menuOpen ? 'translateY(100%)' : (bar.dataset.atcVisible === '1' ? 'translateY(0)' : 'translateY(100%)');
    }).observe(siteHeader, { attributes: true, attributeFilter: ['class'] });
  }

  // Show bar when main ATC button leaves viewport, hide when it returns
  const visibilityObserver = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting }) => {
      bar.dataset.atcVisible = isIntersecting ? '0' : '1';
      bar.style.transform = (!isIntersecting && !menuOpen) ? 'translateY(0)' : 'translateY(100%)';
    });
  }, { threshold: 0 });
  visibilityObserver.observe(mainAtcBtn);

  function syncPrice() {
    const mainPriceEl = document.querySelector('.price-main');
    if (!mainPriceEl) return;
    const text = mainPriceEl.textContent.trim();
    if (stickyPriceEl) stickyPriceEl.textContent = text;
    if (drawerPriceEl) drawerPriceEl.textContent = text;
  }

  const mainPriceContainer = document.querySelector('.price');
  if (mainPriceContainer) {
    new MutationObserver(syncPrice).observe(mainPriceContainer, {
      childList: true, subtree: true, characterData: true,
    });
  }
  syncPrice();

  function syncDrawerBtnState() {
    if (!drawerSubmit) return;
    const isOOS = mainAtcBtn.classList.contains('has-out-of-stock');
    drawerSubmit.disabled = isOOS;
    drawerSubmit.classList.toggle('opacity-50', isOOS);
    drawerSubmit.classList.toggle('cursor-not-allowed', isOOS);
    drawerSubmit.textContent = isOOS ? 'Out of Stock' : 'Add to Cart';
  }

  function populateDrawerOptions() {
    if (!mainOptionsEl || !optionsContainer) return;
    optionsContainer.innerHTML = '';
    const clone = mainOptionsEl.cloneNode(true);

    clone.querySelectorAll('[id]').forEach(el => { el.id = 'sticky-' + el.id; });
    clone.querySelectorAll('[for]').forEach(el => {
      el.setAttribute('for', 'sticky-' + el.getAttribute('for'));
    });
    clone.querySelectorAll('[form]').forEach(el => { el.removeAttribute('form'); });

    // Mirror current selection from main inputs
    mainOptionsEl.querySelectorAll('.option-value').forEach(mainInput => {
      clone.querySelectorAll('.option-value').forEach(ci => {
        if (ci.name === mainInput.name && ci.value === mainInput.value) {
          ci.checked = mainInput.checked;
        }
      });
    });

    // Drawer input change → sync main inputs and update variant/price/ATC directly.
    // We avoid dispatching click on main inputs because productForm's handlers call
    // document.querySelectorAll(".option") which also finds the cloned drawer fieldsets,
    // causing double-counting and disabling clone inputs.
    clone.querySelectorAll('.option-value').forEach(cloneInput => {
      cloneInput.addEventListener('change', () => {
        const changedIdx = cloneInput.dataset.optionIndex; // "option1", "option2", "option3"

        // Mirror only the changed option group to main inputs
        mainOptionsEl.querySelectorAll('.option-value').forEach(mi => {
          if (mi.name === cloneInput.name) {
            mi.checked = (mi.value === cloneInput.value);
          }
        });

        // Collect current selections from main inputs
        const sel = {};
        mainOptionsEl.querySelectorAll('.option-value:checked').forEach(input => {
          sel[input.dataset.optionIndex] = input.value;
        });

        const variants = (typeof productVariants !== 'undefined') ? productVariants : [];

        // Try exact combination first; if missing, fall back to best match for the changed option
        let found = variants.find(v =>
          (!sel.option1 || v.option1 === sel.option1) &&
          (!sel.option2 || v.option2 === sel.option2) &&
          (!sel.option3 || v.option3 === sel.option3)
        );

        if (!found) {
          // Exact combo doesn't exist — find first available variant with the changed option value
          const candidates = variants.filter(v => v[changedIdx] === cloneInput.value);
          found = candidates.find(v => v.available) || candidates[0];
        }

        if (found) {
          // Update hidden variant ID
          const variantIdInput = document.querySelector('.product-variant-id');
          if (variantIdInput) variantIdInput.value = found.id;

          // Sync main inputs to the resolved variant (cascades other options if we fell back)
          mainOptionsEl.querySelectorAll('.option-value').forEach(mi => {
            mi.checked = (mi.value === found[mi.dataset.optionIndex]);
          });

          // Sync clone inputs so the drawer reflects the resolved state
          clone.querySelectorAll('.option-value').forEach(ci => {
            ci.checked = (ci.value === found[ci.dataset.optionIndex]);
          });

          const addToCartBtn = document.querySelector('.add-to-cart-button');
          if (addToCartBtn) {
            addToCartBtn.classList.toggle('has-out-of-stock', !found.available);
          }

          updatePrice(found);
        }

        setTimeout(syncPrice, 50);
        setTimeout(syncDrawerBtnState, 80);
      });
    });

    optionsContainer.appendChild(clone);
  }

  function openDrawer() {
    populateDrawerOptions();
    stickyQty = parseInt(mainQtyInput?.value, 10) || 1;
    if (qtyDisplay) qtyDisplay.textContent = stickyQty;
    syncDrawerBtnState();

    drawer.classList.remove('hidden');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      sheet.style.transform = 'translateY(0)';
    }));
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    sheet.style.transform = 'translateY(100%)';
    setTimeout(() => {
      drawer.classList.add('hidden');
      document.body.style.overflow = '';
    }, 300);
  }

  trigger?.addEventListener('click', () => {
    const hasOptions = mainOptionsEl && mainOptionsEl.querySelector('.option-value');
    if (hasOptions) {
      openDrawer();
    } else {
      mainAtcBtn.click();
    }
  });

  backdrop?.addEventListener('click', closeDrawer);

  qtyMinus?.addEventListener('click', () => {
    if (stickyQty > 1) {
      stickyQty--;
      if (qtyDisplay) qtyDisplay.textContent = stickyQty;
    }
  });

  qtyPlus?.addEventListener('click', () => {
    stickyQty++;
    if (qtyDisplay) qtyDisplay.textContent = stickyQty;
  });

  drawerSubmit?.addEventListener('click', () => {
    if (mainAtcBtn.classList.contains('has-out-of-stock')) return;
    const prevQty = mainQtyInput?.value;
    if (mainQtyInput) mainQtyInput.value = stickyQty;
    mainAtcBtn.click();
    if (mainQtyInput && prevQty) setTimeout(() => { mainQtyInput.value = prevQty; }, 100);
    closeDrawer();
  });

  new MutationObserver(syncDrawerBtnState).observe(mainAtcBtn, {
    attributes: true, attributeFilter: ['class'],
  });
}

window.onload = (event) => {
  sideCartScrollLock();
  mobileMenu();
  footerMenu();
  pagination();
  productGallery();
  productForm();
  stickyATC();
  heroSlider();
  brandsSlider();
  productTabs();
  productInfoTabs();
  imageGallery();
  relatedProducts();
  loginPage();
  accountForm();
  filters();
  contactPage();
  searchForm();
  mobilePredictiveSearch();
  childrenCollections();
  headerCollectionMenu();
  fittingSlider();
  multipleVariantItems();
  updatePriceSubscriptionTime();

  const myCartWatcher = new CartWatcher();
  myCartWatcher.init();
  window.addEventListener("cart_changed", (e) => {
    updatePriceSubscriptionTime();
  });

  const bookingFormEl = document.querySelector("[data-booking-form]");
  if (bookingFormEl) {
    bookingForm();
  }
  setTimeout(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has("variant")) {
      const options = document.querySelectorAll(".option");
      if (options) {
        // Select the first available option in the last option group to initialize the variant selection
        options.forEach((option, index) => {
          if (index == options.length - 1) {
            const firstAvailableOption = option.querySelector(
              "input[type='radio']:not(.disabled)",
            );
            if (firstAvailableOption) {
              firstAvailableOption.click();
            } else {
              const fallbackOption = option.querySelector(
                "input[type='radio'], input[type='checkbox']",
              );
              if (fallbackOption) {
                fallbackOption.click();
              }
            }
          }
        });
      }
    }
  }, 750); //has to be done because of wishlist

  initSwatches();
};

function initSwatches() {
  // Show more swatches logic
  document
    .querySelectorAll(".js-show-more-swatches:not(.js-swatch-initialized)")
    .forEach((btn) => {
      btn.classList.add("js-swatch-initialized");
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const container = this.closest(".swatch-container");
        if (container) {
          container
            .querySelectorAll(".js-hidden-swatch")
            .forEach((el) => el.classList.remove("hidden"));
          this.remove();
        }
      });
    });

  // Archive/Collection Swatch Logic
  const cardSwatches = document.querySelectorAll(
    '.swatch-element[data-layout="card"]:not(.js-swatch-initialized)',
  );
  cardSwatches.forEach((swatch) => {
    swatch.classList.add("js-swatch-initialized");
    swatch.addEventListener("click", function (e) {
      e.preventDefault();

      // Update visual state
      const container = this.closest(".swatch-container");
      if (container) {
        container.querySelectorAll(".swatch-element").forEach((el) => {
          el.classList.remove("!border-dark-blue");
        });
        this.classList.add("!border-dark-blue");
      }

      const variantImage = this.getAttribute("data-variant-image");
      const variantPrice = this.getAttribute("data-variant-price");
      const variantComparePrice = this.getAttribute(
        "data-variant-compare-price",
      );
      const variantUrl = this.getAttribute("data-variant-url");

      const carContainer = this.closest(".product");
      if (carContainer) {
        // Update Image
        if (variantImage) {
          const imgTag = carContainer.querySelector('img[data-original-image]');
          if (imgTag) {
            imgTag.src = variantImage;
            if (imgTag.srcset) imgTag.srcset = variantImage;
          }
        }

        // Update URL
        if (variantUrl) {
          carContainer
            .querySelectorAll('a[href*="/products/"]')
            .forEach((link) => {
              link.href = variantUrl;
            });
        }

        // Update Price
        if (variantPrice) {
          const priceContainer = carContainer.querySelector(".product-price");
          if (priceContainer) {
            let priceHtml = "";
            const isSale =
              variantComparePrice && variantComparePrice !== variantPrice;

            if (isSale) {
              priceHtml = `
                        <del class="mr-1 text-xs md:text-sm text-slate-700">${variantComparePrice}</del>
                        <span class="text-xs font-semibold text-red-500 md:text-sm">${variantPrice}</span>
                    `;
            } else {
              priceHtml = `
                        <span class="text-sm font-semibold text-slate-700 md:text-base">${variantPrice}</span>
                    `;
            }
            priceContainer.innerHTML = priceHtml;
          }
        }
      }
    });
  });
}
